<template>
   <div class="explore-charts">
      <!-- Header -->
      <h2 class="explore-charts__header">{{ chartData.header }}</h2>

      <!-- Paragraph -->
      <p class="explore-charts__para">
         {{ descriptionJoiner(chartData.shortDescription) }}
      </p>

      <!-- Cards List -->
      <ul class="row explore-charts__list p-0">
         <li v-for="(item, index) in chartData.cards" :key="index" class="item">
            <div class="card" :class="cardBehaviour ? 'card-behaviour' : ''">
               <img
                  v-if="requiredImageTag"
                  class="card-img-top"
                  :class="imgFix"
                  :src="item.imgUrl"
                  alt="Card image cap"
                  :height="imgHeight"
               />
               <div v-if="requiredSpanTag" class="icon-wrapper">
                  <span :class="[item.className, `${item.className}-dims`]"></span>
               </div>
               <div class="card-body card__body" :class="fixPaddingTop">
                  <h5 class="card-title card__title">{{ item.cardHeader }}</h5>
                  <p class="card-text">
                     {{ item.cardDescription }}
                  </p>
               </div>
               <div v-if="requiredAnchorTag" class="card-footer card__footer">
                  <a
                     :href="item.cardUrl"
                     class="btn btn-outline-secondary btn-sm btn--cust"
                     @click.prevent="goTo(item.cardUrl)"
                     >{{ ctaName }}</a
                  >
               </div>
            </div>
         </li>
      </ul>
   </div>
</template>

<script>
export default {
   name: 'Cards',
   props: {
      chartData: {
         type: Object,
         default: () => {},
      },
      imgHeight: {
         type: String,
         default: '',
      },
      ctaName: {
         type: String,
         default: 'explore',
      },
      imgFix: {
         type: String,
         default: '',
      },
      requiredSpanTag: {
         type: Boolean,
         default: false,
      },
      requiredImageTag: {
         type: Boolean,
         default: true,
      },
      requiredAnchorTag: {
         type: Boolean,
         default: true,
      },
      cardBehaviour: {
         type: Boolean,
         default: true,
      },
      fixPaddingTop: {
         type: String,
         default: '',
      },
   },

   methods: {
      goTo(url) {
         this.$router.push(url).catch(() => {});
      },
   },
};
</script>

<style lang="scss" scoped>
.explore-charts {
   .imgfix {
      padding: 24px;
      max-width: 350px;
      height: 200px;
      margin: 0 auto;
   }
   .icon-wrapper {
      width: 110px;
      height: 81px;
      margin: 24px 24px 0 14.5px;
      transform: scale(0.8);
   }
   .fix-padding-top {
      padding-top: 8px !important;
   }
   &__header {
      letter-spacing: 0.43px;
      line-height: 38px;
   }
   &__para {
      letter-spacing: 0.2px;
      color: #313131;
      margin-bottom: 2.4rem;
   }
   &__list {
      list-style-type: none;
      margin: 0 -11px;
      .item {
         display: flex;
         width: calc(33.3%);
         padding: 0 11px;
         margin-bottom: 24px;
         @media (max-width: 800px) {
            width: calc(50%);
         }
         @media (max-width: 500px) {
            width: calc(100%);
         }
      }
      .card {
         width: 100%;
         &__body {
            padding-top: 20px;
            padding-bottom: 20px;
         }
         &__title {
            margin-bottom: 10px !important;
         }
         &__footer {
            padding-top: 0;
            .btn {
               min-width: unset;
            }
            .btn--cust {
               border-radius: 4px !important;
            }
         }
      }
      .card-behaviour {
         box-shadow: 0 11px 15px 0 rgba(62, 57, 107, 0.04);
         transition: all ease 0.3s;
         &:hover {
            transform: translateY(-4px);
         }
      }
   }

   %icon {
      background-repeat: no-repeat;
      background-image: url('../../../public/images/react-integration-details-2.svg');
      background-image: url('../../../public/images/react-integration-details-2.png');
      display: block;
   }
   .icon-interactivity_ease,
   .icon-interactivity_ease\:regular {
      @extend %icon;
      background-position: 0 0;
   }
   .fc-website-cross-platform {
      background-image: url('../../../public/images/fc-website-cross-platform.png');
      display: block;
      width: 110px;
      height: 70px;
      background-repeat: no-repeat;
   }
   .fc-website-hotreload {
      background-image: url('../../../public/images/fc-website-hotreload.png');
      display: block;
      width: 110px;
      height: 70px;
      background-repeat: no-repeat;
   }
   .fc-website-flutter-widgets {
      background-image: url('../../../public/images/fc-website-flutter-widgets.png');
      display: block;
      width: 110px;
      height: 70px;
      background-repeat: no-repeat;
   }
   .fc-website-headless-testing {
      background-image: url('../../../public/images/fc-website-headless-testing.png');
      display: block;
      width: 110px;
      height: 71px;
   }
   .fc-website-native-performance {
      background-image: url('../../../public/images/nativeperformance.png');
      width: 110px;
      height: 71px;
      display: block;
   }
   .fc-website-faster-development {
      background-image: url('../../../public/images/fasterdevelopment.png');
      width: 110px;
      height: 71px;
      display: block;
   }
   .icon-interactivity_ease-dims {
      width: 110px;
      height: 71px;
   }
   .icon-control_configuration,
   .icon-control_configuration\:regular {
      @extend %icon;
      background-position: 0 -71px;
   }
   .icon-control_configuration-dims {
      width: 86px;
      height: 60px;
   }
   .icon-data_binding,
   .icon-data_binding\:regular {
      @extend %icon;
      background-position: 0 -131px;
   }
   .icon-data_binding-dims {
      width: 103px;
      height: 64px;
   }
   .icon-data_types,
   .icon-data_types\:regular {
      @extend %icon;
      background-position: 0 -195px;
   }
   .icon-data_types-dims {
      width: 110px;
      height: 81px;
   }
   .icon-no_js,
   .icon-no_js\:regular {
      @extend %icon;
      background-position: 0 -276px;
   }
   .icon-no_js-dims {
      width: 86px;
      height: 56px;
   }
   .icon-open_source,
   .icon-open_source\:regular {
      @extend %icon;
      background-position: 0 -332px;
   }
   .icon-open_source-dims {
      width: 98px;
      height: 63px;
   }
   .icon-charts_maps,
   .icon-charts_maps\:regular {
      @extend %icon;
      background-position: 0 -395px;
   }
   .icon-charts_maps-dims {
      width: 96px;
      height: 69px;
   }
}
</style>
